// Before the browser creates documents under a table — a profile import, a new
// data profile — confirm the table still exists and is not being deleted (M233).
// The backend freezes its own workers when a deletion begins, but the security
// rules do not freeze browser writes, so a table deleted from another tab would
// otherwise gain ghost documents from this one.
//
// The check runs INSIDE the caller's transaction: the table read joins the
// transaction, so a deletion that begins between the read and the commit makes
// the commit fail and retry, and the retry sees the stamp. A separate read before
// a plain write would leave exactly that gap open.
import { doc } from 'firebase/firestore';
import { db } from './firebase';
import { isTableUsable } from '../utils/tableLifecycle';

export async function assertTableAcceptsWrites(transaction, companyId, tableId) {
  const snapshot = await transaction.get(doc(db, `users/${companyId}/tables/${tableId}`));
  if (!snapshot.exists()) {
    throw new Error('This table no longer exists.');
  }
  if (!isTableUsable({ id: tableId, ...snapshot.data() })) {
    throw new Error('This table is being deleted.');
  }
}
